export default {
  tourUi: {
    loading: "Chargement de l'excursion...",
    status: {
      unavailable: 'Indisponible',
    },
    backToTours: 'Retour aux excursions',
    seo: {
      keywordPrefix: 'excursion Paraty',
      breadcrumbHome: 'Accueil',
      breadcrumbTours: 'Excursions',
      touristTypes: ['Famille', 'Couple', 'Aventure'],
    },
    gallery: {
      expand: "Agrandir l'image",
      close: 'Fermer',
      photoAlt: '{{title}} - photo {{n}}',
      thumbAlt: '{{title}} - miniature {{n}}',
    },
    booking: {
      pixDeposit: 'Acompte via Pix',
      remaining: 'Solde à régler le jour même',
      depositNote: "Acompte de {{rate}} % du total, avec un minimum de R$ 20,00.",
      depositFixedPerson: 'Acompte de {{amount}} par personne.',
      depositFixedBooking: 'Acompte fixe de {{amount}} par réservation.',
      depositMixed: 'L’acompte additionne la part de chaque excursion (pourcentage ou montant fixe), avec un minimum de R$ 20,00.',
      fullNote: 'Le prix total de l’excursion est payé maintenant pour garantir la réservation.',
      minDate: 'Choisissez une date à partir du {{date}}.',
      seatsLeft_one: 'Il ne reste que {{count}} place disponible pour cette excursion.',
      seatsLeft_other: 'Il ne reste que {{count}} places disponibles pour cette excursion.',
      decrease: 'Diminuer {{label}}',
      increase: 'Augmenter {{label}}',
    },
  },
};
